const language = {
    'pt': 
        {
            add_link:           'Adicionar link',
            add_new:            'Adicionar novo',
            add_trainer:        'Adicionar formador',
            all:                 'Todos',
            attendance:         'Presenças',
            attendance_mark_unmark_all: 'Marcar/desmarcar todos',
            attendance_present:  'Presente',
            attendance_record:  'Registo de presenças',
            attendance_record_label:  'Legenda',
            attendance_record_missed:  'Faltou',
            attendance_record_present:  'Presente',
            attendance_record_soon:  'Sessão por realizar ou sem data definida',
            attendance_register:  'Registar presenças',
            attendance_view:    'Ver registo',
            avaiable:           'Disponível até',
            available_vacancies:    'Nº de vagas disponíveis',
            available_vacancies_placeholder:    'Introduza as vagas disponíveis',
            back:               'Voltar',
            cancel:             'Cancelar',
            close:              'Fechar',
            content:            'Módulos',
            content_edit:       'Editar módulo',
            content_gest:       'Gestão do módulo',
            content_new:        'Novo módulo',
            content_list:       'Lista de módulos por curso',
            choose_option:      'Escolha uma opção',
            dates:              'Datas',
            date_creation:      'Criação',
            date_avaiable:      'Disponível até',
            date_publication:   'Publicação',
            date_begin:         'Início',
            date_end:           'Fim',
            date_extension:     'Prorrogação',
            date_last_update:   'Última actualização',
            delete:             'Eliminar',
            delete_title:       'Eliminar Registo',
            delete_text:        'Tem a certeza que pretende continuar?',
            delete_confirm:     'Sim',
            delete_cancel:      'Não',
            delete_error:       'Problema ao apagar registo!',
            delete_success:     'Registo apagado com sucesso!',
            draft:              'Rascunho',
            documents:          'Documentos',
            doc_choose:         'Escolher documentos',
            duration:           'Duração (horas)',
            duration_placeholder: 'Introduza o número de horas',
            edit:               'Editar',
            edit_title:         'Editar Registo',
            edit_text:          'Tem a certeza que pretende continuar?',
            edit_confirm:       'Sim',
            edit_cancel:        'Não',
            edit_error:         'Problema ao actualizar registo!',
            edit_success:       'Registo actualizado com sucesso!',
            evaluation:         'Avaliação',
            evaluations_number: 'Nº de Avaliações',
            evaluations_number_placeholder:            'Inserir o número de avaliações',
            field_description:  'Descrição',
            field_name:         'Nome',
            field_name_placeholder:   'Inserir nome',
            field_project_area:     'Área temática',
            field_project_program:  'Programa',
            field_project_domain:   'Dominio',
            field_project_scope:    'Ambito Territorial',
            field_project_fund:     'Fundo',
            field_text:         'Texto',
            field_title:        'Título',
            field_title_placeholder:  'Inserir título',
            field_from:         'De', 
            field_to:           'Para',
            field_subject:      'Assunto',
            field_message:      'Mensagem',
            file_attach:        'Attach file',
            file_list:        'Lista de ficheiros',
            file_remove_all:    'Remove all',
            file_upload:        'Upload file',
            file_upload_all:    'Upload all',
            file_view:          'Ver ficheiro',
            files:              'Ficheiro(s)',
            files_view:          'Ver ficheiros',
            filter_placeholder: 'Procurar',
            final_evaluation:   'Avaliação final',
            formation:     'Formação',
            formation_date_start: 'Data de Ínicio',
            formation_date_end: 'Data de Fim',
            formation_language:  'Lingua da formação',
            formation_language_pt:  'Português',
            formation_language_en:  'Inglês',
            formation_language_es:  'Espanhol',
            formation_schedule:  'Tipo de Horário',
            formation_schedule_working_hours: 'Laboral',
            formation_schedule_post_work: 'Pós Laboral',
            formation_schedule_flexible: 'Flexivel',
            evaluation_file:            'Envio de Ficheiro',
            evaluation_free_answer:     'Resposta aberta',
            evaluation_multiple_choice: 'Escolha multipla',
            evaluation_question:        'Pergunta',
            gest:               'Gestão',
            id:                 'ID',
            image:              'Imagem de destaque',
            images:             'Imagens',
            image_choose:       'Escolher imagem',
            insert_title:       'Novo Registo',
            insert_text:        'Tem a certeza que pretende continuar?',
            insert_confirm:     'Sim',
            insert_cancel:      'Não',
            insert_error:       'Problema ao inserir registo!',
            insert_success:     'Registo inserido com sucesso!',
            language:            'Língua',
            layout:             'Tipo',
            link_insert:        'Inserir link',
            link_open:          'Abrir link',
            links_empty:        'Não existem links adicionados.',
            links_list:         'Lista de links',
            name:               'Nome',
            message:            'Mensagem',
            message_view:       'Ver mensagem',
            messages:           'Mensagens',
            messages_list:      'Lista de mensagens',
            messages_new:       'Nova mensagem',
            module:            'Módulo',
            module_add:         'Adicionar módulo',
            module_add_info:         'Para adicionar módulos a esta formação, clique primeiro no botão "Salvar".',
            module_data:        'Data',
            module_inicio:      'Início',
            module_fim:         'Fim',
            module_description:     'Descrição',
            module_description_placeholder:            'Inserir descrição do módulo',
            module_evaluation:            'Avaliação',
            module_evaluation_placeholder:            'Inserir método de avaliação',
            module_evaluation_teste_escrito:            'Teste Escrito',
            module_evaluation_avaliacao_oral:            'Avaliação oral',
            module_evaluations:            'Avaliações',
            module_evaluations_files_empty:            'Não existem ficheiros de avaliação deste formando.',
            module_evaluations_soon:            'Avaliação por atribuir',
            module_insert_error: 'Por favor verifique se os campos do nome e descrição estão preenchidos corretamente!',
            module_name:            'Nome',
            module_name_placeholder:            'Inserir nome do módulo',
            module_objectives:            'Objetivos',
            module_objectives_placeholder:            'Inserir objetivos do módulo',
            module_support_material:   'Material de suporte do módulo',
            modules:            'Módulos',
            multimedia:         'Multimédia',
            no_results:         'Sem registos',
            page_config:        'Configuração da Página',
            page_parent:        'Parent',
            pages:              'Páginas',
            pdf_documents:      'Documentos PDF',
            principal:          'Principal',
            published:          'Publicado',
            remove:             'Remover',
            schedule:           'Agendar',
            schedule_to:        'Agendado',
            send:               'Enviar',
            send_title:         'Enviar mensagem',
            send_text:          'Tem a certeza que pretende continuar?',
            send_confirm:       'Sim',
            send_cancel:        'Não',
            send_error:         'Problema enviar mensagem!',
            send_error_subject: 'Preencha o campo do assunto!',
            send_error_message: 'Preencha o campo da mensagem!',
            send_success:       'Mensagem enviada com sucesso!',
            sent:               'Enviado',
            save:               'Salvar',
            seo_config:         'Configuração SEO',
            seo_description:    'Descrição SEO',
            seo_description_placeholder: 'Introduza a descrição SEO',
            seo_keywords:       'Keywords SEO',
            seo_keywords_small: '(separar por virgula)',
            seo_keywords_placeholder: 'Introduza as keywords SEO',
            seo_title:          'Título SEO',
            seo_title_placeholder: 'Introduza o título SEO',
            session:            'Sessão',
            session_evaluation:            'Avaliação da sessão',
            session_name_provisional:         'nome provisório',
            session_notice:             'Aviso',
            session_notice_message_1:             'As sessões apresentadas (e os seus nomes) são provisórias e foram geradas automaticamente a partir do número que foi introduzido no campo "Nº de sessões" do módulo. Para cada sessão ser criada dentro deste módulo tem obrigatóriamente que definir um nome e clicar no botão Salvar.',
            session_notice_message_2:             'Apenas as sessões que têm um nome definido serão criadas dentro deste módulo. Para definir um nome é só preencher o campo "nome" dentro de cada sessão e clicar no botão Salvar.',
            session_support_material:   'Material de suporte da sessão',
            sessions:            'Sessões',
            sessions_empty:     'Não existem sessões neste módulo.',
            sessions_number:    'Nº de Sessões',
            sessions_placeholder: 'Introduza o número de sessões',
            sessions_view:      'Ver sessões',
            support_material:   'Material de suporte',
            state_ended:        'Terminado',
            state_open:         'Em curso',   
            state_to_start:      'Por iniciar',     
            table_rows_per_page:'Registos por página:',
            table_separator:    'de',
            table_all:          'Todos',
            table_title:        'Título',
            table_parent:       'Parent',
            table_date:         'Data',
            table_date_begin:   'Início',
            table_date_end:     'Fim',
            table_state:        'Estado',
            table_actions:      'Acções',
            target_audience:    'Público alvo',
            target_placeholder: 'Introduza o público alvo', 
            tasks:              'Tarefas',
            tasks_module:              'Tarefas do módulo',
            tasks_session:              'Tarefas da sessão',
            tasks_files_empty:              'Não existem ficheiros deste formando',
            trainee: 'Formando(a)',
            trainees: 'Formandos',
            trainees_empty: 'Não existem formandos neste módulo.',
            trainees_empty_2: 'Não existem formandos neste módulo para registar.',
            trainees_empty_3: 'Não existem formandos neste módulo para enviar mensagens.',
            trainer: 'Formador(a)',
            with_emphasis:      'Com destaque',         
            without_emphasis:   'Sem destaque',
        },
    'en':
        {
            add_link:           'Add link',
            add_new:            'Add new',
            add_trainer:        'Adicionar formador',
            all:                 'All',
            attendance:         'Attendance',
            attendance_mark_unmark_all: 'Mark/unmark all',
            attendance_present:  'Present',
            attendance_record:  'Attendance record',
            attendance_record_label:  'Label',
            attendance_record_missed:  'Missed',
            attendance_record_present:  'Attend',
            attendance_record_soon:  'Sessão por realizar ou sem data definida',
            attendance_register:  'Register attendance',
            attendance_view:    'View attendance',
            avaiable:           'Avaiable until',
            available_vacancies:    'Nº of available vacancies',
            available_vacancies_placeholder:    'Insert the available vacancies',
            back:               'Back',
            cancel:             'Cancel',
            close:              'Close',
            content:            'Modules',
            content_edit:       'Edit module',
            content_gest:       'Module gest',
            content_new:        'New formation',
            content_list:       'Module list by course',
            choose_option:      'Choose an option',
            dates:              'Dates',
            date_creation:      'Creation',
            date_avaiable:      'Avaiable until',
            date_publication:   'Publication',
            date_begin:         'Begin',
            date_end:           'End',
            date_extension:     'Extension',
            date_last_update:   'Last update',
            delete:             'Delete',
            delete_title:       'Delete Regist',
            delete_text:        'Are you sure you want to continue?',
            delete_confirm:     'Yes',
            delete_cancel:      'No',
            delete_error:       'Problem deleting the element!',
            delete_success:     'Element deleted successfully!',
            draft:              'Draft',
            documents:          'Documents',
            doc_choose:         'Choose documents',
            duration:           'Duration (hours)',
            duration_placeholder: 'Insert the number of hours',
            edit:               'Edit',
            edit_title:         'Edit Regist',
            edit_text:          'Are you sure you want to continue?',
            edit_confirm:       'Yes',
            edit_cancel:        'No',
            edit_error:         'Problem updating element!',
            edit_success:       'Successful updated element!',
            evaluation:         'Evaluation',
            evaluations_number: 'Nº de Avaliações',
            evaluations_number_placeholder:            'Inserir o número de avaliações',
            field_description:  'Description',
            field_name:         'Name',
            field_name_placeholder: 'Insert the name',
            field_project_area:     'Thematic Area',
            field_project_program:  'Program',
            field_project_domain:   'Dommain',
            field_project_scope:    'Trritorial Scope',
            field_project_fund:     'Fund',
            field_text:         'Text',
            field_title:        'Title',
            field_title_placeholder:  'Insert title',
            field_from:         'De', 
            field_to:           'Para',
            field_subject:      'Assunto',
            field_message:      'Mensagem',
            file_attach:        'Attach file',
            file_list:          'File List',
            file_remove_all:    'Remove all',
            file_upload:        'Upload file',
            file_upload_all:    'Upload all',
            file_view:          'View file',
            files:              'File(s)',
            files_view:          'View files',
            filter_placeholder: 'Search',
            final_evaluation:   'Final evaluation',
            formation:     'Formation',
            formation_date_start: 'Start Date',
            formation_date_end: 'End Date',
            formation_language:  'Formation Language',
            formation_language_pt:  'Portuguese',
            formation_language_en:  'English',
            formation_language_es:  'Spanish',
            formation_schedule:  'Schedule type',
            formation_schedule_working_hours: 'Working Hours',
            formation_schedule_post_work: 'Post Work',
            formation_schedule_flexible: 'Flexible',
            evaluation_file:            'Send file',
            evaluation_free_answer:     'Free answer',
            evaluation_multiple_choice: 'Escolha multipla',
            evaluation_question:        'Question',
            gest:               'Gest',
            id:                 'ID',
            language:            'Language',
            layout:             'Type',
            link_insert:        'Insert link',
            link_open:          'Open link',
            links_empty:        'There are no links added.',
            links_list:         'Links list',
            name:               'Nome',
            message:            'Mensagem',
            message_view:       'Ver mensagem',
            messages:           'Mensagens',
            messages_list:      'Lista de mensagens',
            messages_new:       'Nova mensagem',
            module:            'Module',
            module_add:         'Add module',
            module_add_info:         'To add modules to this formation, click first in button "Save".',
            module_description:     'Description',
            module_description_placeholder:            'Insert module description',
            module_evaluation:            'Evaluation',
            module_evaluation_placeholder:            'Insert evaluation method',
            module_evaluation_teste_escrito:            'Teste Escrito',
            module_evaluation_avaliacao_oral:            'Avaliação oral',
            module_evaluations:            'Evaluations',
            module_evaluations_files_empty:            'There are no evaluation files from this trainee.',
            module_evaluations_soon:            'Avaliação por atribuir',
            module_insert_error: 'Por favor verifique se os campos do nome e descrição estão preenchidos corretamente!',
            module_name:            'Module name',
            module_name_placeholder:            'Insert module name',
            module_objectives:            'Objetivos',
            module_objectives_placeholder:            'Inserir objetivos do módulo',
            module_data:        'Data',
            module_inicio:      'Início',
            module_fim:         'Fim',
            module_support_material:   'Module support material',
            modules:            'Modules',
            multimedia:         'Multimedia',
            no_results:         'No results',
            image:              'Highlight image',
            images:             'Images',
            image_choose:       'Choose image',
            insert_title:       'New Regist',
            insert_text:        'Are you sure you want to continue?',
            insert_confirm:     'Yes',
            insert_cancel:      'No',
            insert_error:       'Problem updating element!',
            insert_success:     'Successful updated element!',
            page_config:        'Page config',
            page_parent:        'Parent',
            pages:              'Pages',
            pdf_documents:      'PDF Documents',
            principal:          'Principal',
            published:          'Publicado',
            remove:             'Remove',
            save:               'Save',
            schedule:           'Schedule',            
            schedule_to:        'Schedule', 
            send:               'Enviar',
            send_title:         'Enviar mensagem',
            send_text:          'Tem a certeza que pretende continuar?',
            send_confirm:       'Sim',
            send_cancel:        'Não',
            send_error:         'Problema enviar mensagem!',
            send_error_subject: 'Preencha o campo do assunto!',
            send_error_message: 'Preencha o campo da mensagem!',
            send_success:       'Mensagem enviada com sucesso!',
            sent:               'Sent',
            seo_config:         'SEO config',
            seo_description:    'SEO description',
            seo_description_placeholder: 'Insert the SEO description',
            seo_keywords:       'SEO keywords',
            seo_keywords_small: '(separate by comma)',
            seo_keywords_placeholder: 'Insert the SEO keywords',
            seo_title:          'SEO title',
            seo_title_placeholder: 'Insert the SEO title',
            session:            'Session',
            session_evaluation:            'Session evaluation',
            session_name_provisional:         'nome provisório',
            session_notice:             'Aviso',
            session_notice_message_1:             'A lista de sessões apresentada (e os seus nomes) é provisória e foi gerada automaticamente a partir do número que introduziu no campo "Nº de sessões" do módulo. Para cada sessão ser criada dentro deste módulo tem obrigatóriamente que definir um nome para cada sessão e clicar no botão Salvar.',
            session_notice_message_2:             'Apenas as sessões que têm um nome definido serão criadas dentro deste módulo. Para definir um nome é só preencher o campo "nome" dentro de cada sessão e clicar no botão Salvar.',
            session_support_material:   'Session support material',
            sessions:            'Sessions',
            sessions_empty:     'There are no sessions in this module.',
            sessions_number:    'Nº of Sessions',
            sessions_placeholder: 'Insert the number of sessions',
            sessions_view:      'Sessions view',
            support_material:   'Support material',
            state_ended:        'Ended',
            state_open:         'In progress',  
            state_to_start:     'To start', 
            table_rows_per_page:'Regist by page:',
            table_separator:    'of',
            table_all:          'All',
            table_title:        'Title',
            table_parent:       'Parent',
            table_date:         'Date',
            table_date_begin:   'Begin',
            table_date_end:     'End',
            table_state:        'State',
            table_actions:      'Actions',
            target_audience:    'Target',
            target_placeholder: 'Insert the target audicence',
            tasks:              'Tasks',
            tasks_module:              'Module tasks',
            tasks_session:              'Session tasks',
            tasks_files_empty:  'There are no files from this trainee.',
            trainee:            'Trainee',
            trainees:           'Trainees',
            trainees_empty:     'There are no trainees in this module.',
            trainees_empty_2:   'There are no trainees in this module to regist.',
            trainees_empty_3:   'There are no trainees in this module to send messages.',
            trainer:           'Trainer',
            with_emphasis:      'With emphasis',         
            without_emphasis:   'Without emphasis',
        }
}

module.exports = {
    language
};